// Role tiers from the replication guide, section 3.
// store / viewer (0) < manager / regional_manager (1) < template_manager (2) < admin (3)
export const ROLES = ['store', 'viewer', 'manager', 'regional_manager', 'template_manager', 'admin'] as const;
export type Role = (typeof ROLES)[number];

export const ROLE_LEVELS: Record<Role, number> = {
  store: 0,
  viewer: 0,
  manager: 1,
  regional_manager: 1,
  template_manager: 2,
  admin: 3,
};

export const ROLE_LABELS: Record<Role, string> = {
  store: 'Store (kitchen tablet)',
  viewer: 'Viewer',
  manager: 'Store Manager',
  regional_manager: 'Regional Manager',
  template_manager: 'Template Manager',
  admin: 'Admin',
};

export function roleLevel(role: Role): number {
  return ROLE_LEVELS[role] ?? 0;
}

// Admins see every store; everyone else only sees stores assigned to them.
export function seesAllStores(role: Role): boolean {
  return role === 'admin';
}
